module.exports = __webpack_public_path__ + "media/images/thank-tablet-bfedb76542a333738c416f6df9a580e7.jpg";